import React, { useEffect, useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import {
  CategoryFragment,
  useCategoryByIdLazyQuery,
  useServiceQuery,
} from 'generated/graphql';
import { MAIN_CATEGORY } from 'constants/constants';
import CategoryItems from 'components/CategoryItems/CategoryItems';
import Loader from 'components/Loader/Loader';
import PromoBanner from 'components/PromoBanner/PromoBanner';
import Page404 from 'pages/Page404/Page404';
import Error from 'pages/Error/Error';

function MainPage() {
  const { params } = useRouteMatch<{ alias: string, id: string }>();
  const currentCategoryAlias = useMemo(() => (params?.alias ? params.alias : MAIN_CATEGORY), [params]);
  const [loadCategory, {
    data, loading, error, fetchMore,
  }] = useCategoryByIdLazyQuery();

  async function fetchMoreCallback(category: CategoryFragment) {
    if (fetchMore) {
      await fetchMore({
        variables: {
          id: category.id,
          limit: 8,
          offset: (category.contents) ? category.contents.length : 0,
        },
      });
    }
  }

  const location = useLocation();
  const match = location.pathname === '/';

  const { data: serviceData, loading: serviceLoading, error: errorLoading } = useServiceQuery({
    variables: {
      lang: ['ru'],
    },
  });

  const categories = serviceData?.point?.service.categories;
  const categoryId = categories?.find((i) => i.alias === currentCategoryAlias)?.id || categories?.[0]?.id;

  useEffect(() => {
    if (categoryId) {
      loadCategory({
        variables: {
          id: categoryId,
          offset: 0,
          limit: 8,
          lang: ['ru'],
        },
      });
    }
  }, [categoryId]);

  const category = data?.point?.service.category;

  if (loading || serviceLoading) return <Loader />;

  if (error?.message.includes('invalid syntax')
        || error?.message.includes('bad key')) return <Page404 />;

  if (error || errorLoading) return <Error />;

  return (
    <>
      {match && <PromoBanner />}
      {category
             && (
             <CategoryItems
               category={category}
               alias={currentCategoryAlias}
               title={category?.name || ''}
               fetchMore={fetchMoreCallback}
             />
             )}
    </>
  );
}

export default MainPage;
